import "./App.css";
import Intro from "./Intro";
import Body from "./Body";
import Contact from "./Contact";

function App() {
  return (
    <div>
      <Intro />
      <Body />
      <Contact />
    </div>
  );
}

export default App;
